'use strict';

function isAuthenticated(history) {
  const user = JSON.parse(localStorage.getItem('auth'));
  if(!user){
    history.push('/sign-in')
  }
}
export {isAuthenticated};
